namespace $.$$ {
	export class $yuf_number extends $.$yuf_number {
		
		override blur_event() {
			const next = this.value(this.value_string() ? undefined : this.value_min())
			this.value_string(String(next || ''))
		}

		// override allow_enriched() {
		// 	return `${this.allow()}${this.value_min() < 0 ? '-' : ''}${this.precision() >= 1 ? '' : '.'}`
		// }
		
	}
}
